import React  from 'react'
import { Layout } from 'antd';
import './App.css';
import {setGlobal} from 'reactn'
import SidebarMenu from './components/sidebarmenu';
import AppHeader from './components/appheader';
import AppFooter from './components/appfooter';
import AppContent from './components/appcontent';
import WrappedNormalLoginForm from './components/login';
import WrappedRecoverPasswordForm from './components/recover'
import "moment/locale/en-nz"
import moment from "moment"


let toDate = moment()
let fromDate = moment().day(0)
//console.log("setGlobal")
setGlobal( {
  toDate: toDate,
  fromDate: fromDate,
  member: {}
}) 



const {
  Header, Footer, Content,
} = Layout;

const App = (props) => {

  let currentUser = window.sessionStorage.getItem("UserName") || "";
  let userRole = window.sessionStorage.getItem("UserRole") || "";
  let isLogin = currentUser.length > 0;
  const footerStyle = { fontSize: "10px", padding: "5px 10px", backgroundColor: "#4996de" };
  const LoginPage = () => {
    let isRecover = (window.location.pathname.toLowerCase() === '/recover')
    return (
      <div className="login">
        {isRecover? <WrappedRecoverPasswordForm />: <WrappedNormalLoginForm />}
      </div>
    )
  }

  const HomePage = () => {
    //console.log("rendering homepage...")
    let OrgName = window.sessionStorage.getItem("OrganisationName")
    return (
      <Layout>
        <SidebarMenu userRole={userRole} />
        <Layout>
          <Header><AppHeader OrgName={OrgName} currentUser={currentUser} /></Header>
          <Content>
            <AppContent currentUser={currentUser} userRole={userRole} />
          </Content>
          <Footer style={footerStyle} ><AppFooter /></Footer>
        </Layout>
      </Layout>)
  }
  //return ( <HomePage /> )
  return (isLogin ? <HomePage /> : <LoginPage />)
}

export default App;

